import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { compose } from 'redux';

import {
  withContext,
  withQueryParams,
} from 'redpoints-front-common/components';

import {
  shortenerResolutionClear,
  shortenerResolutionFetchDomains,
  shortenerResolutionFetchLinkToResolve,
  shortenerResolutionSetFiltersSelected,
} from '../../../actions/shortenerResolutionActions';
import {
  getShortenerResolutionDomainsIsLoaded,
  getShortenerResolutionFiltersApplied,
  getShortenerResolutionFiltersSelected,
} from '../../../reducers/tasks/shortenerResolution';
import ShortenerResolutionFilters from './ShortenerResolutionFilters';
import ShortenerResolutionLinkToResolve from './ShortenerResolutionLinkToResolve';
import useShortenerResolutionReloadDomains from './hooks/useShortenerResolutionReloadDomains';
import useShortenerResolutionSetInitialData from './hooks/useShortenerResolutionSetInitialData';

import './shortenerResolution.less';

const ShortenerResolution = ({
  customer: { customerId },
  filtersApplied,
  filtersSelected,
  isLoadedDomains,
  queryParams,
  shortenerResolutionClear,
  shortenerResolutionFetchDomains,
  shortenerResolutionFetchLinkToResolve,
  shortenerResolutionSetFiltersSelected,
}) => {
  const hasFiltersApplied = isEqual(filtersApplied, filtersSelected);
  const { isEnableFilterByTenant } = useShortenerResolutionSetInitialData({
    customerId,
    filtersApplied,
    hasFiltersApplied,
    isLoadedDomains,
    queryParams,
    shortenerResolutionFetchDomains,
    shortenerResolutionFetchLinkToResolve,
    shortenerResolutionSetFiltersSelected,
  });

  useShortenerResolutionReloadDomains({
    customerId,
    filtersSelected,
    isLoadedDomains,
    shortenerResolutionFetchDomains,
  });

  useEffect(() => {
    return () => {
      shortenerResolutionClear();
    };
  }, [shortenerResolutionClear]);

  return (
    <>
      <ShortenerResolutionFilters
        isEnableFilterByTenant={isEnableFilterByTenant}
      />
      <ShortenerResolutionLinkToResolve />
    </>
  );
};

const mapStateToProps = (state, { queryParams }) => ({
  filtersApplied: getShortenerResolutionFiltersApplied(state, queryParams),
  filtersSelected: getShortenerResolutionFiltersSelected(state),
  isLoadedDomains: getShortenerResolutionDomainsIsLoaded(state),
});

export default compose(
  withContext,
  withQueryParams,
  connect(mapStateToProps, {
    shortenerResolutionClear,
    shortenerResolutionFetchDomains,
    shortenerResolutionFetchLinkToResolve,
    shortenerResolutionSetFiltersSelected,
  })
)(ShortenerResolution);
